<script lang="ts">
	//Formating
	import { format } from 'svelte-i18n';
	//Design system components
	import { Slider, Toggle, ColorWheel } from '@Shelly/shelly-design-system';
	//Helpers
	import { percent_from_value_range, value_from_percent_range } from 'src/helpers/utilities';
	//Types
	import type { LocalControlOptions } from 'src/types/requests/schedules/schedules_g2';

	export let controlOption: LocalControlOptions;

	let white = 0;
	const whiteProps = {
		min: 0,
		max: 255,
		onInit: (white: number) => {
			return percent_from_value_range(white, [0, 255]);
		},
		onChange: (white: number) => {
			return value_from_percent_range(white, [0, 255]);
		},
	};

	if (controlOption.attr?.white != undefined) {
		white = whiteProps.onInit(controlOption.params.white || whiteProps.min);
	}
	const a11yPropsSliderWhite = {
		sliderValueText: $format('current_white_brightness_value', {
			values: { value: controlOption.params.white || 0 },
			default: `Current white brightness value is ${controlOption.params.white || 0}`,
		}),
		ariaLabel: $format('label_set_white_brightness_property', {
			default: 'Set White Brightness property',
		}),
		ariaLabelValue: $format('current_white_brightness_value', {
			values: { value: controlOption.params.white || 0 },
			default: `Current white brightness value is ${controlOption.params.white || 0}`,
		}),
	};
</script>

<div>
	<Toggle class="mb-xs" size="m" bind:checked={controlOption.attr.rgb} id="toggle-hoxki7l">
		{$format('label_set_color_property', {
			default: 'Set Color property',
		})}
	</Toggle>

	<div class="d-flex justify-content-center">
		<div style="max-width: 300px;">
			<ColorWheel
				id="colorwheel-vk93yxy"
				valuesType={controlOption.attr.rgb ? 'input' : 'label'}
				color={{
					r: controlOption.params.rgb[0],
					g: controlOption.params.rgb[1],
					b: controlOption.params.rgb[2],
				}}
				class="mb-xs"
				disabled={!controlOption.attr.rgb}
				hideSaveBtn
				on:color_change={(event) => {
					const c = event.detail.color;
					controlOption.params.rgb = [c.r, c.g, c.b];
				}}
			/>
		</div>
	</div>

	{#if controlOption.attr?.white != undefined}
		<Toggle class="mb-xs" size="m" bind:checked={controlOption.attr.white} id="toggle-1wat9ou">
			{$format('label_set_white_brighÏtness_property', {
				default: 'Set White brightness property',
			})}
		</Toggle>

		<Slider
			id="slider-ty5wpxi"
			a11yProps={a11yPropsSliderWhite}
			type="simple"
			value={white}
			disabled={!controlOption.attr.white}
			on:value_change={(e) => {
				white = e.detail.value;
				controlOption.params.white = whiteProps.onChange(white);
			}}
			title={$format('label_white_brightness_slider_title', {
				values: {
					min: whiteProps.min,
					max: whiteProps.max,
					white: controlOption.params.white,
				},
				default: `Selected:{white}, Range: {min} (Min) - {max} (Max)`,
			})}
		/>
	{/if}
</div>
